// Дозапрос почтового индекса у Google, когда улица пришла из саджеста,
// а номер дома пользователь ввёл вручную.

// Страны, для которых логика включена. Пока только РФ.
const POSTINDEX_LOOKUP_COUNTRIES = ['RU']

const BUILD_FIELD = 'BUILD'
const STREET_FIELD = 'STREET'
const POSTINDEX_FIELD = 'POSTINDEX'
const CITY_FIELD = 'CITY'

function normalize(value) {
  return typeof value === 'string' ? value.trim() : ''
}

// Поле, покидание которого запускает проверку.
export function isBuildField(fieldName) {
  return fieldName === BUILD_FIELD
}

export function isPostindexLookupCountry(countryCode) {
  return POSTINDEX_LOOKUP_COUNTRIES.includes(countryCode)
}

export function shouldRequestPostindex({
  countryCode,
  pickedFromSuggest,
  profile,
  lastLookupBuild,
} = {}) {
  if (!isPostindexLookupCountry(countryCode)) return false
  if (!pickedFromSuggest) return false

  const fields = profile || {}
  const street = normalize(fields[STREET_FIELD])
  const build = normalize(fields[BUILD_FIELD])
  const postindex = normalize(fields[POSTINDEX_FIELD])

  if (!street || !build || postindex || build === normalize(lastLookupBuild)) {
    return false
  }

  return true
}

export function buildPostindexQuery(profile) {
  const fields = profile || {}
  const city = normalize(fields[CITY_FIELD])
  const street = normalize(fields[STREET_FIELD])
  const build = normalize(fields[BUILD_FIELD])

  if (!city || !street || !build) return ''

  return [city, street, build].join(', ')
}
